import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
    persistReducer, persistStore
} from "redux-persist";
import storage from "redux-persist-indexeddb-storage";
import { rxdApi } from "../actions/rtkquery";
import userSliceWithTokenValidation from "./features/userSliceWithTokenValidation";
// import userslice from "./features/userslice";
// import userSliceWithTokenValidation from "./features/userSliceWithTokenValidation";

const persistConfig = {
    key: "rxd-storage",
    storage: storage("rxd-storage"),
    // SECURITE : ne jamais persister le cache API (rxdApi) — il contient des
    // donnees par utilisateur et provoquerait une fuite de donnees entre comptes.
    whitelist: ["auth"],
}

const appReducer = combineReducers({
    [rxdApi.reducerPath]: rxdApi.reducer,


    // user: userslice, // !OPTION1: a utiliser si vous ne faites pas une validation de token
    auth: userSliceWithTokenValidation, // Option2: à utiliser si vous faites une validation de token
})

// SECURITE : au logout, on reinitialise TOUT le store (y compris le cache
// RTK Query) pour qu'aucun residu du compte precedent ne survive au
// changement d'utilisateur.
const rootReducers = (state, action) => {
    if (action.type === "auth/logout") {
        state = undefined;
    }
    return appReducer(state, action);
}

const persistedReducer = persistReducer(persistConfig, rootReducers)

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }).concat(rxdApi.middleware),
})

export const persistor = persistStore(store);